import { CreatableListValueSeparator } from './types.js';
export const PLACEHOLDERS = {
    input: 'Search or create item',
    copy: 'Copy',
    copied: 'Copied',
    paste: 'Paste',
    pasted: 'Pasted',
    apply: 'Apply',
    applied: 'Applied',
    clearAll: 'Clear all',
    selected: 'Selected:',
    create: 'Create',
    total: 'Total',
    totalSeparator: 'of',
    sortOrderAsc: 'A-Z',
    sortOrderDesc: 'Z-A',
    errorTitle: 'Error',
    errorAccessDenied: 'Clipboard access denied',
    errorAccessError: 'Clipboard access error',
    errorValueExists: 'Value already exists',
    errorValueEmpty: 'Value cannot be empty',
};
export const SUGGESTIONS_MIN_QUERY_LENGTH = 2;
export const SUGGESTIONS_LIMIT = 6;
/** Key name shown on the active suggestion; a key name is not translated. */
export const SUGGESTION_PICK_KEY_HINT = 'Enter';
export const LIST_MAX_HEIGHT = 333;
export const ITEM_HEIGHT = 37;
export const SEPARATOR_SPLIT_PATTERN = {
    [CreatableListValueSeparator.COMMA]: ',',
    [CreatableListValueSeparator.SEMICOLON]: ';',
    [CreatableListValueSeparator.TAB]: '\\t',
    [CreatableListValueSeparator.NEWLINE]: '\\r?\\n+',
};
export const SEPARATOR_CONTAINS_REGEX = {
    [CreatableListValueSeparator.COMMA]: /,/,
    [CreatableListValueSeparator.SEMICOLON]: /;/,
    [CreatableListValueSeparator.TAB]: /\t/,
    [CreatableListValueSeparator.NEWLINE]: /\r?\n/,
};
export const DEFAULT_VALUE_SEPARATORS = [CreatableListValueSeparator.COMMA];
export const ALL_VALUE_SEPARATORS = Object.values(CreatableListValueSeparator);
